export const SET_SHOW_SUMMARY = 'SET_SHOW_SUMMARY';

export const setShowSummary = status => ({
    type: SET_SHOW_SUMMARY,
    payload: status,
})